import { default as initCommonDataStore } from "../../../../lib/common/js/dataStore"
import Bugsnag from "@bugsnag/js"

// Ideally, naming from pipeline config should match with used in common code.
// But historically it's not the case, so we need this adapter.
const customOfferFieldsKeysAdapter = (key) => {
  const pricingKeysAdapter = {
    price_no_discount: "total_price_without_discount",
    price_per_period_no_discount: "period_price_without_discount",

    price: "total_price",
    price_per_period: "period_price",
    price_discount: "discount",
    price_discount_amount: "total_price_discount",

    chance_price: "chance_price",
    chance_price_per_period: "chance_period_price",
    chance_price_discount: "chance_discount",
    chance_price_discount_amount: "chance_price_discount",

    trial_price: "trial_price",
    trial_price_per_period: "trial_period_price",
    trial_price_discount: "trial_discount",
    trial_price_discount_amount: "trial_price_discount_amount",

    chance_trial_price: "chance_trial_price",
    chance_trial_price_per_period: "chance_trial_price_per_period",
    chance_trial_price_discount: "chance_trial_price_discount",
    chance_trial_price_discount_amount: "chance_trial_price_discount_amount",
  }

  return pricingKeysAdapter[key] || key
}

function getInitialValues() {
  return {
    // Globals
    usePaymentsApi: true,
    token: null,
    measurementSystem: pipelineConfig.measurementSystem,
    domain: null,
    activeOffer: null,
    privacyAgreement: false,
    marketingAgreed: null,
    cookiePolicyBannerAccepted: null,
    purchasedBasicOffer: null,
    skippedUpsellOffers: [],
    checkout: null,
    initiateCheckoutAt: null,
    isEmailStepCompleted: false,
    exitIntent: false,
    isExitIntentPopupShown: false,
    isPaymentLoading: false,
    segmentUserId: null,

    // Pipe form
    gender: "female",
    desiredGoal: null,
    howLongSinceIdealWeight: null,
    whyLoseWeight: [],
    defineYourDiet: [],
    foodAllergies: [],
    menopause: null,
    weightLossKnowledge: null,
    physicallyActive: null,
    applyToYou: [],
    snackingTriggers: [],
    diseases: [],
    mood: null,
    howBusy: null,
    mealPrep: null,
    age: null,
    heightFt: null,
    heightIn: null,
    heightCm: null,
    weightKg: null,
    weightLbs: null,
    helpAfterMenopause: null,
    targetWeightKg: null,
    targetWeightLbs: null,
    firstName: null,
    flushesAndSweating: null,
    dryerSkin: null,
    hormonalTherapy: null,
    email: null,
    selectedChatNutrionist: null,
  }
}

// Define data values to be used in this specific pipe variation
// and feed them to the basic data store creator fn, which is placed
// in the `lib` under current pipe series folder.
const dataStore = {
  ...initCommonDataStore({
    getInitialValues,
    customOfferFieldsKeysAdapter,
  }),

  // All variation-specific props and methods can de added or overwritten below:
  // isMetric() { },
}

export default dataStore
